import './access.svelte.css.proxy.js';
/* src/routes/access.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	query_selector_all,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import Nav from "../../_components/navigation/Nav.svelte.js";
import Wrap from "../../_components/slot/Wrap.svelte.js";
import Inner from "../../_components/slot/Inner.svelte.js";
import Section from "../../_components/slot/Section.svelte.js";
import Columns from "../../_components/column/Columns.svelte.js";
import Column from "../../_components/column/Column.svelte.js";
import Breadcrumb from "../../_components/block/Breadcrumb.svelte.js";
import Title from "../../_components/block/Title.svelte.js";
import Heading from "../../_components/block/Heading.svelte.js";
import Hr from "../../_components/element/Hr.svelte.js";
import Item from "../../_components/slot/Item.svelte.js";
import Table from "../../_components/element/Table.svelte.js";
import Maps from "../../_components/access/Maps.svelte.js";

function create_default_slot_17(ctx) {
	let breadcrumb;
	let t;
	let title;
	let current;
	breadcrumb = new Breadcrumb({ props: { paths: /*paths*/ ctx[0] } });

	title = new Title({
			props: { name: "整備工場・アクセス", en: "Access" }
		});

	return {
		c() {
			create_component(breadcrumb.$$.fragment);
			t = space();
			create_component(title.$$.fragment);
		},
		l(nodes) {
			claim_component(breadcrumb.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(title.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(breadcrumb, target, anchor);
			insert(target, t, anchor);
			mount_component(title, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(breadcrumb.$$.fragment, local);
			transition_in(title.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(breadcrumb.$$.fragment, local);
			transition_out(title.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(breadcrumb, detaching);
			if (detaching) detach(t);
			destroy_component(title, detaching);
		}
	};
}

// (33:0) <Section kind="top-small">
function create_default_slot_16(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_17] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (42:4) <Inner>
function create_default_slot_15(ctx) {
	let maps;
	let current;

	maps = new Maps({
			props: {
				name: "本社工場",
				tel: "027-231-9008",
				code: "371-0018",
				address: "群馬県前橋市三俣町2丁目1-3",
				fax: "027-231-9231",
				src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3211.425065072299!2d139.08074185120918!3d36.398909879935196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601ef3a8354fc103%3A0xb10ffd0200cc8708!2z44CSMzcxLTAwMTgg576k6aas55yM5YmN5qmL5biC5LiJ5L-j55S677yS5LiB55uu77yR4oiS77yT!5e0!3m2!1sja!2sjp!4v1613206602961!5m2!1sja!2sjp"
			}
		});

	return {
		c() {
			create_component(maps.$$.fragment);
		},
		l(nodes) {
			claim_component(maps.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(maps, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(maps.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(maps.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(maps, detaching);
		}
	};
}

// (41:2) <Wrap>
function create_default_slot_14(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_15] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (40:0) <Section kind="top-small">
function create_default_slot_13(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_14] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (67:6) <Item>
function create_default_slot_12(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("県都・前橋の市街地にあるロケーションをいかし、普通自動車の整備を中心に行っている工場です。工場内には、完成検査ラインも有しています。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "県都・前橋の市街地にあるロケーションをいかし、普通自動車の整備を中心に行っている工場です。工場内には、完成検査ラインも有しています。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (58:4) <Inner>
function create_default_slot_11(ctx) {
	let figure;
	let img;
	let img_src_value;
	let t;
	let item;
	let current;

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			figure = element("figure");
			img = element("img");
			t = space();
			create_component(item.$$.fragment);
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", {});
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, srcset: true, alt: true });
			figure_nodes.forEach(detach);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/factory-01.jpg")) attr(img, "src", img_src_value);
			attr(img, "srcset", "/images/factory-01-SP.jpg 768w, /images/factory-01.jpg");
			attr(img, "alt", "本社工場");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(figure);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (57:2) <Wrap>
function create_default_slot_10(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (56:0) <Section kind="small">
function create_default_slot_9(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (75:2) <Inner>
function create_default_slot_8(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (74:0) <Wrap>
function create_default_slot_7(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (82:4) <Inner>
function create_default_slot_6(ctx) {
	let maps;
	let current;

	maps = new Maps({
			props: {
				name: "芳賀特装工場",
				tel: "027-269-0012",
				code: "371-0018",
				address: "群馬県前橋市鳥取町646-3",
				fax: "027-269-0096",
				src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3210.703893855792!2d139.10425271564077!3d36.416358780029434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601ef3c15d26a9d7%3A0x94301a5c5c3579c1!2z44CSMzcxLTAxMzEg576k6aas55yM5YmN5qmL5biC6bOl5Y-W55S677yW77yU77yW4oiS77yT!5e0!3m2!1sja!2sjp!4v1613207607360!5m2!1sja!2sjp"
			}
		});

	return {
		c() {
			create_component(maps.$$.fragment);
		},
		l(nodes) {
			claim_component(maps.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(maps, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(maps.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(maps.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(maps, detaching);
		}
	};
}

// (81:2) <Wrap>
function create_default_slot_5(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (80:0) <Section kind="top-small">
function create_default_slot_4(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (106:6) <Item>
function create_default_slot_3(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("高所作業車をはじめとした特装車や自主検査が義務付けられている建設機械、フォークリフト等の専門整備工場になっています。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "高所作業車をはじめとした特装車や自主検査が義務付けられている建設機械、フォークリフト等の専門整備工場になっています。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (97:4) <Inner>
function create_default_slot_2(ctx) {
	let figure;
	let img;
	let img_src_value;
	let t;
	let item;
	let current;

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			figure = element("figure");
			img = element("img");
			t = space();
			create_component(item.$$.fragment);
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", {});
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, srcset: true, alt: true });
			figure_nodes.forEach(detach);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/factory-02.jpg")) attr(img, "src", img_src_value);
			attr(img, "srcset", "/images/factory-02-SP.jpg 768w, /images/factory-02.jpg");
			attr(img, "alt", "芳賀特装工場");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(figure);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (96:2) <Wrap>
function create_default_slot_1(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (95:0) <Section kind="small">
function create_default_slot(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

function create_fragment(ctx) {
	let meta0;
	let meta1;
	let meta2;
	let meta3;
	let meta4;
	let t0;
	let nav;
	let t1;
	let section0;
	let t2;
	let section1;
	let t3;
	let section2;
	let t4;
	let wrap;
	let t5;
	let section3;
	let t6;
	let section4;
	let current;
	nav = new Nav({ props: { segment: "access" } });

	section0 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_16] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_13] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	section4 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			meta0 = element("meta");
			meta1 = element("meta");
			meta2 = element("meta");
			meta3 = element("meta");
			meta4 = element("meta");
			t0 = space();
			create_component(nav.$$.fragment);
			t1 = space();
			create_component(section0.$$.fragment);
			t2 = space();
			create_component(section1.$$.fragment);
			t3 = space();
			create_component(section2.$$.fragment);
			t4 = space();
			create_component(wrap.$$.fragment);
			t5 = space();
			create_component(section3.$$.fragment);
			t6 = space();
			create_component(section4.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-1cmarmw\"]", document.head);
			meta0 = claim_element(head_nodes, "META", { name: true, content: true });
			meta1 = claim_element(head_nodes, "META", { property: true, content: true });
			meta2 = claim_element(head_nodes, "META", { property: true, content: true });
			meta3 = claim_element(head_nodes, "META", { property: true, content: true });
			meta4 = claim_element(head_nodes, "META", { property: true, content: true });
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			claim_component(nav.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(section0.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(section1.$$.fragment, nodes);
			t3 = claim_space(nodes);
			claim_component(section2.$$.fragment, nodes);
			t4 = claim_space(nodes);
			claim_component(wrap.$$.fragment, nodes);
			t5 = claim_space(nodes);
			claim_component(section3.$$.fragment, nodes);
			t6 = claim_space(nodes);
			claim_component(section4.$$.fragment, nodes);
			this.h();
		},
		h() {
			document.title = "整備工場・アクセス | 協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車";
			attr(meta0, "name", "description");
			attr(meta0, "content", "協和自動車有限会社のアクセス情報です。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta1, "property", "og:url");
			attr(meta1, "content", "https://kyouwaji.com/access/");
			attr(meta2, "property", "og:title");
			attr(meta2, "content", "整備工場・アクセス | 協和自動車有限会社 | 群馬で自動車車検・修理なら協和自動車");
			attr(meta3, "property", "og:description");
			attr(meta3, "content", "協和自動車有限会社のアクセス情報です。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta4, "property", "og:type");
			attr(meta4, "content", "article");
		},
		m(target, anchor) {
			append(document.head, meta0);
			append(document.head, meta1);
			append(document.head, meta2);
			append(document.head, meta3);
			append(document.head, meta4);
			insert(target, t0, anchor);
			mount_component(nav, target, anchor);
			insert(target, t1, anchor);
			mount_component(section0, target, anchor);
			insert(target, t2, anchor);
			mount_component(section1, target, anchor);
			insert(target, t3, anchor);
			mount_component(section2, target, anchor);
			insert(target, t4, anchor);
			mount_component(wrap, target, anchor);
			insert(target, t5, anchor);
			mount_component(section3, target, anchor);
			insert(target, t6, anchor);
			mount_component(section4, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const section0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
			const section3_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
			const section4_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section4_changes.$$scope = { dirty, ctx };
			}

			section4.$set(section4_changes);
		},
		i(local) {
			if (current) return;
			transition_in(nav.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(wrap.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			transition_in(section4.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(nav.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(wrap.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			transition_out(section4.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(meta0);
			detach(meta1);
			detach(meta2);
			detach(meta3);
			detach(meta4);
			if (detaching) detach(t0);
			destroy_component(nav, detaching);
			if (detaching) detach(t1);
			destroy_component(section0, detaching);
			if (detaching) detach(t2);
			destroy_component(section1, detaching);
			if (detaching) detach(t3);
			destroy_component(section2, detaching);
			if (detaching) detach(t4);
			destroy_component(wrap, detaching);
			if (detaching) detach(t5);
			destroy_component(section3, detaching);
			if (detaching) detach(t6);
			destroy_component(section4, detaching);
		}
	};
}

function instance($$self) {
	const paths = [{ name: "HOME", href: "/" }, { name: "整備工場・アクセス" }];
	return [paths];
}

class Access extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Access;
//# sourceMappingURL=access.svelte.js.map
